module.exports = __webpack_public_path__ + "img/yyjc.62975a42.png";